$(".sidebarButton").on('click', function() {
  var sidebarType = $(this).data("sidebar-type");
  var childSidebar = $(`.sidebarParent[data-sidebar-type="${sidebarType}"]`);
  $(this).addClass("active");
  $("body").css({"overflow-y": "hidden"});
  childSidebar.addClass('visible');
  setTimeout(() => {
    childSidebar.find(".sidebarContainer").css({"transform": "translateX(0px)", 'transition-duration': "400ms"});
  }, "0");
});
$(".sidebarParent .fa-solid.fa-circle-xmark").on('click', function() {
  var parentSidebar = $(this).parents(".sidebarParent");
  var sidebarType = parentSidebar.data("sidebar-type");
  var parentContainer = parentSidebar.find(".sidebarContainer");
  $(`.sidebarButton[data-sidebar-type="${sidebarType}"]`).removeClass("active");
  $("body").css({"overflow-y": "auto"});
  parentContainer.css({"transform": "translateX(500px)", 'transition-duration': "400ms"});
  setTimeout(() => {
    parentSidebar.removeClass('visible');
  }, "400");
});